function Hauszeitung_status_select(element) {
    this.$element = $(element);
    this.articleId = null;

    this.selectors = {
      activateButton: '.c-hauszeitung-edit-list__status-button--activate',
      archiveButton: '.c-hauszeitung-edit-list__status-button--archive',
      dateStartContainer: '.c-hauszeitung-edit-list__element--date_start',
      dateEndContainer: '.c-hauszeitung-edit-list__element--date_end',
      statusContainer: '.c-hauszeitung-edit-list__element--status',
    };

    this.init = function() {
      this.articleId = this.$element.attr('data-article-id');

      this.$activateButton = this.$element.find(this.selectors.activateButton);
      this.$archiveButton = this.$element.find(this.selectors.archiveButton);
      this.$dateStartContainer = this.$element.find(this.selectors.dateStartContainer);
      this.$dateEndContainer = this.$element.find(this.selectors.dateEndContainer);
      this.$statusContainer = this.$element.find(this.selectors.statusContainer);

      this.$activateButton.on('click', this.$activateArticle.bind(this));
      this.$archiveButton.on('click', this.$archiveArticle.bind(this));
    };

    this.$activateArticle = function() {
      var param = jQuery.param({
        js: 'Hauszeitung',
        call: 'article_change_status',
        article_id: this.articleId,
        new_status: 'active',
      });
      this.$sendAjax(param);
    };

    this.$archiveArticle = function() {
      var param = jQuery.param({
        js: 'Hauszeitung',
        call: 'article_change_status',
        article_id: this.articleId,
        new_status: 'archive',
      });
      this.$sendAjax(param);
    };

    this.$sendAjax = function (param) {
      i4_Ajax.factory().
        set_parameter(param).
        set_option({
          on_success: ((response) => {
            response = JSON.parse(response);
            // console.log('response', response);
            if (response.status === 'active' || response.status === 'archive') {
              const date_start = this.$convertDate(response.date_start);
              const date_end = this.$convertDate(response.date_end);
              this.$dateStartContainer.text(date_start);
              this.$dateEndContainer.text(date_end);
              this.$statusContainer.text('active');
              this.$makeButtonHighlighted(response.fake_status);
            }
          }).bind(this)
        }).
        run();
    };

    this.$convertDate = function(datetime) {
      const date_array = datetime.split(' ');
      const date = date_array[0];
      const date_parts = date.split('-');
      return date_parts[2] + '.' + date_parts[1] + '.' + date_parts[0];
    };

    this.$makeButtonHighlighted = function(status) {
      // console.log('status', status);
      if (status === 'active') {
        this.$archiveButton.removeClass('i4-button--primary');
        this.$activateButton.addClass('i4-button--primary');
      } else { // archive
        this.$activateButton.removeClass('i4-button--primary');
        this.$archiveButton.addClass('i4-button--primary');
      }
    };
}
